// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7e979473","31":"09a17a31","40":"4a7aca05","131":"5837f08c","206":"2b99484c","229":"a1e9b0da","347":"4ceab40d","428":"cb228df8","453":"545807ac","510":"0205557b","737":"de754a70","743":"1acd2291","755":"79d0ab38","875":"24e0381d","945":"2beff81d","994":"62cebac0"}[chunkId] + ".chunk.js";
};